module.exports = __webpack_public_path__ + "media/reskin-images/icon--lock-00c02e74.svg";